import { all, call, put, select, takeEvery } from "redux-saga/effects";

import { getNewsFailed, getNewsStart, getNewsSuccess } from "../redux/getNews";

import { getNewsApi } from "core/http/service/news";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";

function* getNewsWork(action: ReturnType<typeof getNewsStart>) {
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));

  try {
    const res = yield call(getNewsApi, {
      params: { offset, limit, ...action.payload.params },
    });

    yield put({
      type: getNewsSuccess.type,
      payload: {
        type: action.payload.type,
        data: res.data,
        categoryName: res.categoryName,
      },
    });
  } catch (error: any) {
    yield put({
      type: getNewsFailed.type,
      payload: {
        type: action.payload.type,
      },
    });
  }
}

function* watchGetNews() {
  yield takeEvery(getNewsStart.type, getNewsWork);
}

export default function* getNewsSaga() {
  yield all([watchGetNews()]);
}
